<script setup>
import ProfileForm from "@/components/profile/ProfileForm.vue";
import { useAuthStore } from "@/stores/auth.js";
const auth = useAuthStore();
</script>

<template>
    <ProfileForm :id="auth.user.id" />
</template>
